const UNITS = ["B", "KB", "MB", "GB"];

// An agent decides whether to open an attachment from its size as much as its
// name: a 4 KB logo out of a signature reads differently to a 12 MB x-ray.
export const formatFileSize = (size) => {
  // Number() reads null and an empty string as zero, so a size the API left
  // out would otherwise be stated as 0 B rather than left unsaid.
  if (size === null || size === undefined || size === "") return "";

  const bytes = Number(size);
  if (!Number.isFinite(bytes) || bytes < 0) return "";

  let value = bytes;
  let unit = 0;

  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }

  // Bytes and kilobytes are already fine enough to read whole. A decimal only
  // earns its place from megabytes up, and only while the number is small
  // enough for the decimal to say anything.
  const decimals = unit > 1 && value < 10 ? 1 : 0;

  return `${value.toFixed(decimals)} ${UNITS[unit]}`;
};
